import React, { useCallback, useEffect } from 'react'
import { Switch } from 'react-router-dom'
import { Base64 } from 'js-base64'

import Route from './Route'

import Main from '../pages/01-Main'
import Start from '../pages/04-Start'
import Authenticate from '../pages/x01.1-Auth'
import Redirect from '../pages/x01.2-Redirect'
import Contribution from '../pages/05-Contribution'
import Accession from '../pages/05.1-Accession'
import Simulation from '../pages/06-Simulation'
import Register from '../pages/02-Register'
import ConfirmSMS from '../pages/03-ConfirmSMS'
import PEP from '../pages/07-PEP'
import HasBeneficiaries from '../pages/08-HasBeneficiaries'
import Beneficiary from '../pages/09-Beneficiary'
import Resume from '../pages/10-Resume'
import Conclusion from '../pages/11-Conclusion'
import End from '../pages/12-End'

import Erro from '../pages/990-Erro'
import NotFound from '../pages/991-NotFound'

import { AccessionConfigData, ConfigData } from '../utils/interfaces'
import usePersistedState from '../hooks/usePersistedState'
import clientConfig from '../services/clientConfig'
import api from '../services/api'
import {
  DEFAULT_ACCESSION_CONFIG,
  normalizeAccessionConfig,
} from '../utils/accessionConfig'

const Routes: React.FC = () => {
  const { codCliente, tipo, plano } = clientConfig()

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [, setAccessionConfig] = usePersistedState<AccessionConfigData>(
    'accessionConfig',
    DEFAULT_ACCESSION_CONFIG,
  )

  const loadAccessionConfig = useCallback(async () => {
    const parametrosGet = Base64.encode(
      `{"versao":"${tipo}",
        "plano": "${plano}",
        "cliente":"${codCliente}"}`,
    )

    const parametrosFinalGet = Base64.encode(parametrosGet)

    try {
      const response = await api.get(
        `wsConfiguracaoAdesao.rule?sys=ADZ&Entrada=${parametrosFinalGet}`,
      )
      const normalizedConfig = normalizeAccessionConfig(response.data)

      setAccessionConfig(normalizedConfig)
      localStorage.setItem(
        '@BASF:usb',
        JSON.stringify(normalizedConfig.valorUnidadeReferencia),
      )
      localStorage.setItem(
        '@BASF:tamanhoCodigoValidador',
        JSON.stringify(normalizedConfig.tamanhoCodigoValidador),
      )
    } catch (error) {
      setAccessionConfig(DEFAULT_ACCESSION_CONFIG)
      localStorage.setItem(
        '@BASF:usb',
        JSON.stringify(DEFAULT_ACCESSION_CONFIG.valorUnidadeReferencia),
      )
      localStorage.setItem(
        '@BASF:tamanhoCodigoValidador',
        JSON.stringify(DEFAULT_ACCESSION_CONFIG.tamanhoCodigoValidador),
      )
    }
  }, [codCliente, plano, setAccessionConfig, tipo])

  useEffect(() => {
    setConfigData({
      ...configData,
      codCliente,
      tipo,
      plano,
    })
    loadAccessionConfig()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Switch>
      <Route path="/" exact component={Main} />
      <Route path="/start" exact component={Start} />

      <Route path="/auth" exact component={Authenticate} />
      <Route path="/redirect" exact component={Redirect} />

      <Route path="/contribution" component={Contribution} />
      <Route path="/accession" component={Accession} />
      <Route path="/simulation" component={Simulation} />
      <Route path="/register" exact component={Register} />
      <Route path="/confirm-sms" component={ConfirmSMS} />
      <Route path="/pep" component={PEP} />
      <Route path="/has-beneficiaries" component={HasBeneficiaries} />
      <Route path="/beneficiary" component={Beneficiary} />
      <Route path="/resume" component={Resume} />
      <Route path="/conclusion" component={Conclusion} />
      <Route path="/end" component={End} />

      <Route path="/erro" component={Erro} />
      <Route path="*" component={NotFound} />
    </Switch>
  )
}

export default Routes
